import { Routes } from '@angular/router';
import { clientIdChildGuard, clientIdGuard } from '../guards/client-id/client-id.guard';
import { AcquireOnboardingWizardComponent } from '../components/acquire-onboarding-wizard/acquire-onboarding-wizard.component';
import { ProfileResolver } from '../resolvers/profile.resolver';

export const acquireOnboardingWizardRoutes: Routes = [
    {
        path: 'acquire-onboarding/:clientId/:onboardingId',
        component: AcquireOnboardingWizardComponent,
        canActivate: [clientIdGuard],
        canActivateChild: [clientIdChildGuard],
        resolve: { profile: ProfileResolver },
        children: [
            {
                path: '',
                redirectTo: 'decision',
                pathMatch: 'full',
            },
            {
                path: 'decision',
                loadComponent: () =>
                    import('../components/acquire-onboarding-wizard/merchant-decision/merchant-decision.component').then(
                        (m) => m.MerchantDecisionComponent
                    ),
            },
            {
                path: 'spreadsheet-upload-create-multiple-merchants',
                loadComponent: () =>
                    import('../components/acquire-onboarding-wizard/spreadsheet-upload/spreadsheet-upload-create-multiple-merchants/spreadsheet-upload-create-multiple-merchants.component').then(
                        (m) => m.SpreadsheetUploadCreateMultipleMerchantsComponent
                    ),
            },
            {
                path: 'mids',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        loadComponent: () =>
                            import('../components/acquire-onboarding-wizard/mids-decision/mids-decision.component').then(
                                (m) => m.MidsDecisionComponent
                            ),
                    },
                    {
                        path: 'form',
                        loadComponent: () =>
                            import('../components/acquire-onboarding-wizard/acquire-mids-information/acquire-mids-information.component').then(
                                (m) => m.AcquireMidsInformationComponent
                            ),
                    },
                    {
                        path: 'upload',
                        loadComponent: () =>
                            import('../components/acquire-onboarding-wizard/spreadsheet-upload/spreadsheet-upload/spreadsheet-upload.component')
                                .then(m => m.SpreadsheetUploadComponent),
                    },
                    { path: '**', redirectTo: '' },
                ]
            },
            {
                path: 'client-data-review',
                loadComponent: () =>
                    import('../components/acquire-onboarding-wizard/acquire-client-data-review/acquire-client-data-review.component').then(
                        (m) => m.AcquireClientDataReviewComponent
                    ),
            },
            // {
            //     path: 'mids-information',
            //     loadComponent: () =>
            //         import('../components/acquire-onboarding-wizard/acquire-mids-information/acquire-mids-information.component').then(
            //             (m) => m.AcquireMidsInformationComponent
            //         ),
            // },
            {
                path: 'configure-services',
                loadComponent: () =>
                    import('../components/acquire-onboarding-wizard/configure-services/configure-services.component').then(
                        (m) => m.ConfigureServicesComponent
                    ),
            },
            {
                path: 'review-submit',
                loadComponent: () =>
                    import('../components/acquire-onboarding-wizard/review-submit/review-submit.component').then(
                        (m) => m.ReviewSubmitComponent
                    ),
            },
            {
                path: 'merchant-handoff',
                loadComponent: () =>
                    import(
                        '../components/acquire-onboarding-wizard/merchant-handoff/merchant-handoff.component'
                    ).then((m) => m.MerchantHandoffComponent),
            },
        ],
    },
];
